import {
  getLdsOrderAgentDisplayMessage,
  getLdsOrderBusinessStatusLabelHe,
  isKnownBusinessStatus,
} from "./ldsOrderStatus";
import { resolveMixedPaymentDisplayState } from "./orders/resolveMixedPaymentDisplayState";

const PREAUTH_LABEL =
  "תשלום: סכום הורשה בכרטיס; החיוב הסופי יבוצע לאחר אישור ההזמנה";

function pickFirstNonEmpty(values) {
  for (const value of values) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return "";
}

function resolveFromPaymentStatusCode(rawValue) {
  const raw = String(rawValue || "").trim();
  if (!raw) return null;
  const status = raw.toLowerCase();
  const map = {
    paid: "שולם",
    pending: "ממתין לתשלום",
    failed: "תשלום נכשל",
    cancelled: "בוטל",
    awaiting_bank_transfer: "ממתין להעברה בנקאית",
    bank_transfer: "ממתין להעברה בנקאית",
    waiting_for_payment: "ממתין לתשלום",
    booked: "מאושרת",
  };
  if (map[status]) return map[status];
  if (
    status.includes("auth") ||
    status.includes("preauth") ||
    status.includes("pre_auth") ||
    status.includes("authorized") ||
    status.includes("authorised")
  ) {
    return PREAUTH_LABEL;
  }
  return raw;
}

export function resolveOrderPaymentStatusLabel(
  orderData,
  paymentContext,
  fallbackData
) {
  const explicitOrderStatus = pickFirstNonEmpty([
    orderData?.status_label,
    orderData?.statusLabel,
    orderData?.paymentDescription,
    orderData?.order?.status_label,
    orderData?.order?.statusLabel,
    orderData?.order_response?.status_label,
    orderData?.order_response?.statusLabel,
  ]);
  if (explicitOrderStatus) {
    return {
      label: explicitOrderStatus,
      source: "order.explicit_status_label",
      raw: explicitOrderStatus,
      hasStatus: true,
    };
  }

  const paymentStatusRaw = pickFirstNonEmpty([
    orderData?.payment_status,
    orderData?.paymentStatus,
    orderData?.orderStatus,
    orderData?.order?.payment_status,
    orderData?.order?.paymentStatus,
    paymentContext?.payment_status,
    paymentContext?.paymentStatus,
    paymentContext?.orderStatus,
    fallbackData?.payment_status,
    fallbackData?.paymentStatus,
    fallbackData?.orderStatus,
  ]);
  if (paymentStatusRaw) {
    return {
      label: resolveFromPaymentStatusCode(paymentStatusRaw),
      source: "order.payment_status",
      raw: paymentStatusRaw,
      hasStatus: true,
    };
  }

  const authStatusRaw = pickFirstNonEmpty([
    orderData?.authorizationStatus,
    orderData?.authorization_status,
    orderData?.order?.authorizationStatus,
    orderData?.order?.authorization_status,
    paymentContext?.authorizationStatus,
    paymentContext?.authorization_status,
    fallbackData?.authorizationStatus,
    fallbackData?.authorization_status,
  ]);
  if (authStatusRaw) {
    return {
      label: resolveFromPaymentStatusCode(authStatusRaw),
      source: "order.authorization_status",
      raw: authStatusRaw,
      hasStatus: true,
    };
  }

  const agentLine =
    getLdsOrderAgentDisplayMessage(orderData) ||
    getLdsOrderAgentDisplayMessage(paymentContext) ||
    getLdsOrderAgentDisplayMessage(fallbackData);
  if (agentLine) {
    return {
      label: agentLine,
      source: "order.agent_display_message",
      raw: agentLine,
      hasStatus: true,
    };
  }

  for (const src of [orderData, paymentContext, fallbackData]) {
    const mixed = resolveMixedPaymentDisplayState(src);
    if (mixed.applies && mixed.displayStatus) {
      return {
        label: mixed.displayStatus,
        source: "order.mixed_payment_display",
        raw: mixed.displayStatusKey,
        hasStatus: true,
        badges: mixed.badges,
      };
    }
  }

  const businessStatus = pickFirstNonEmpty([
    orderData?.business_status,
    paymentContext?.business_status,
    fallbackData?.business_status,
  ]);
  if (isKnownBusinessStatus(businessStatus)) {
    return {
      label: getLdsOrderBusinessStatusLabelHe(businessStatus, "full"),
      source: "order.business_status",
      raw: businessStatus,
      hasStatus: true,
    };
  }

  return {
    label: "חסר מידע",
    source: "missing",
    raw: "",
    hasStatus: false,
  };
}

